import { t } from "@/i18n-js/instance";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";

export interface ListFieldItemActionsProps {
  isDeleteDisabled: boolean;
  onClickAddLink: () => void;
  onClickDelete: () => void;
  onClickDuplicate: () => void;
}

export const ListFieldItemActions = ({
  onClickDelete,
  onClickDuplicate,
  onClickAddLink,
  isDeleteDisabled = false,
}: ListFieldItemActionsProps) => (
  <div className="flex items-center gap-2">
    {!isDeleteDisabled && (
      <IconButton
        name="16-trash-bin-2"
        ariaLabel={t("builder_ui.prop_type.list.delete_item")}
        onClick={onClickDelete}
        title={t("builder_ui.prop_type.list.delete_item")}
      />
    )}
    <IconButton
      name="16-copy"
      ariaLabel={t("builder_ui.prop_type.list.duplicate_item")}
      onClick={onClickDuplicate}
      title={t("builder_ui.prop_type.list.duplicate_item")}
    />
    <IconButton
      name="16-link"
      ariaLabel={t("builder_ui.prop_type.list.add_link")}
      onClick={onClickAddLink}
      title={t("builder_ui.prop_type.list.add_link")}
    />
  </div>
);
